import { I18n } from '@calendly/i18n'

import {
  PERSONAL_SECURITY_BASE,
  PROFILE_SETTINGS_BASE,
  personalBrowserTabTarget,
} from './personal_browser_urls'

/**
 * Profile settings tab strip for the settings modal memory router (nested paths).
 * Browser URLs use {@link getProfileSettingsBrowserTabs} instead.
 */
export function getProfileSettingsTabs() {
  return [
    { title: I18n.t('publisher.account_settings.profile.tabs.general'), route: `${PROFILE_SETTINGS_BASE}/general` },
    { title: I18n.t('publisher.account_settings.profile.tabs.login'), route: `${PROFILE_SETTINGS_BASE}/login` },
  ]
}

/**
 * Profile settings tab strip for the legacy full-page shell (monolith-safe base path + query).
 */
export function getProfileSettingsBrowserTabs() {
  return [
    {
      title: I18n.t('publisher.account_settings.profile.tabs.general'),
      route: personalBrowserTabTarget(PROFILE_SETTINGS_BASE, 'general'),
    },
    {
      title: I18n.t('publisher.account_settings.profile.tabs.login'),
      route: personalBrowserTabTarget(PROFILE_SETTINGS_BASE, 'login'),
    },
  ]
}

/**
 * Personal Security — monolith-safe browser tab strip for the legacy full page.
 * @param {object} flags
 * @param {boolean} flags.bookingVerificationEnabled
 * @param {boolean} flags.reactiveBlockEnabled
 */
export function getPersonalSecurityBrowserTabs({ bookingVerificationEnabled, reactiveBlockEnabled }) {
  const tabs = []
  if (bookingVerificationEnabled) {
    tabs.push({
      title: I18n.t('publisher.admin.security.tabs.booking'),
      route: personalBrowserTabTarget(PERSONAL_SECURITY_BASE, 'booking'),
    })
  }
  if (reactiveBlockEnabled) {
    tabs.push({
      title: I18n.t('publisher.admin.security.tabs.blocked_sources'),
      route: personalBrowserTabTarget(PERSONAL_SECURITY_BASE, 'blocked_sources'),
    })
  }
  return tabs
}

/**
 * Personal Privacy — settings modal tab strip (memory router nested paths).
 * Reuses the existing security routes so legacy deep links and route sync keep working.
 * @param {object} flags
 * @param {boolean} flags.bookingVerificationEnabled — `trust_and_safety_email_verification_feature`
 * @param {boolean} flags.reactiveBlockEnabled — `trust_and_safety_reactive_block`
 */
export function getPersonalPrivacyTabs({ bookingVerificationEnabled, reactiveBlockEnabled }) {
  const tabs = []
  if (bookingVerificationEnabled) {
    tabs.push({
      title: I18n.t('publisher.personal_settings.privacy.tabs.booking'),
      route: '/app/personal/security/booking',
    })
  }
  if (reactiveBlockEnabled) {
    tabs.push({
      title: I18n.t('publisher.personal_settings.privacy.tabs.blocked_people'),
      route: '/app/personal/security/blocked_sources',
    })
  }
  tabs.push({
    title: I18n.t('publisher.personal_settings.privacy.tabs.cookies'),
    route: '/app/personal/security/cookies',
  })
  return tabs
}
